export default __webpack_public_path__ + "static/media/car-door.dbd5ae83.png";